import type { ComponentProps } from "react";
import { Button } from "@repo/ui";
import { cn } from "@repo/utils";
import type { ListStatuses } from "~/types/api";

export type StatusItemBaseProps = {
  status: ListStatuses;
  isSelected: boolean;
  onToggle?: (code: number) => void;
};

type Props = Omit<ComponentProps<typeof Button>, keyof StatusItemBaseProps | "children"> &
  StatusItemBaseProps & {
    isDragging?: boolean;
  };

export const StatusItem = ({
  status,
  isSelected,
  onToggle,
  isDragging,
  className,
  ...rest
}: Props) => (
  <Button
    type="button"
    variant="ghost"
    {...rest}
    className={cn(
      "h-fit w-full rounded bg-blue-50 px-2 py-1 transition-colors",
      {
        "border border-blue-300 bg-blue-100": isSelected,
        "hover:bg-gray-50": !isSelected,
        "opacity-40": isDragging,
      },
      className
    )}
    onClick={onToggle ? () => onToggle(status.code) : undefined}
  >
    <div className="w-full space-x-2 text-left">
      <span className="w-12 font-mono text-sm font-bold">{status.code}</span>
      <span className="text-sm font-normal">{status.name}</span>
    </div>
  </Button>
);
